<template>
    <BasePanel :alvqa="alvqa" headline="lang_GENERIC_AZ_PANEL_CAPTION_MAPPINGS">
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <!-- Publishing statements -->
                <v-col cols="3">
                    <v-row class="pb-3 headline">
                        <div class="headline mx-4">
                            {{ $t('lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_STATEMENTS') }}
                        </div>
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingSummaryMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_SUMMARY_MAPPING')"
                            :alvqa="alvqa + '-publishing-summary-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingDetailsMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_DETAILS_MAPPING')"
                            :alvqa="alvqa + '-publishing-details-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingPerWorkMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PER_WORK_MAPPING')"
                            :alvqa="alvqa + '-publishing-perwork-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingProjectsSheetsMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PROJECTS_SHEETS_MAPPING')"
                            :alvqa="alvqa + '-publishing-projects-sheets-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingTop10MappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_TOP_10_MAPPING')"
                            :alvqa="alvqa + '-publishing-top-10-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getPublishingPayeeMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PAYEE_MAPPING')"
                            :alvqa="alvqa + '-publishing-payee-mapping'"
                        />
                    </v-row>
                </v-col>

                <!-- Label statements -->
                <v-col cols="3">
                    <v-row class="pb-3 headline">
                        <div class="headline mx-4">
                            {{ $t('lang_GENERIC_CAPTION_INTERESTS_LABEL_ROYALTY_STATEMENTS') }}
                        </div>
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLabelDigitalMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_DIGITAL_MAPPING')"
                            :alvqa="alvqa + '-label-digital-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLabelRetailMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_RETAIL_MAPPING')"
                            :alvqa="alvqa + '-label-retail-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLabelLicenseMappingDisplay"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_LICENSE_MAPPING')"
                            :alvqa="alvqa + '-label-license-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseReadOnlyTextField
                            :innerValue="getLabelPerReleaseMappingDisplay"
                            :label="$te('lang_GENERIC_AZ_CAPTION_LABEL_PER_RELEASE_MAPPING') ? $t('lang_GENERIC_AZ_CAPTION_LABEL_PER_RELEASE_MAPPING') : 'Statement per release (Label)'"
                            :alvqa="alvqa + '-label-per-release-mapping'"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'

export default {
    name: "AzPersonsMappingsReadOnlyPanel",
    components: {
        BasePanel,
        BaseReadOnlyTextField
    },
    props: {
        azPersonsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'az-persons-list-read-only-panel-mappings'
        }
    },
    computed: {
        getPublishingSummaryMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingSummaryMapping)
        },
        getPublishingDetailsMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingDetailsMapping)
        },
        getPublishingPerWorkMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingPerWorkMapping)
        },
        getPublishingProjectsSheetsMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingProjectsSheetsMapping)
        },
        getPublishingTop10MappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingTop10Mapping)
        },
        getPublishingPayeeMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsPublishingPayeeMapping)
        },
        getLabelDigitalMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsLabelDigitalMapping)
        },
        getLabelRetailMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsLabelRetailMapping)
        },
        getLabelLicenseMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsLabelLicenseMapping)
        },
        getLabelPerReleaseMappingDisplay() {
            return this.mapMappingDisplay(this.$store.getters.getAzPersonsMetadataDetailsLabelPerReleaseMapping)
        }
    },
    methods: {
        mapMappingDisplay(alvId) {
            if (!alvId) return ''
            const mappings = this.$store.getters.getMappings || []
            const found = mappings.find(m => m && (m.alvId === alvId || m.id === alvId))
            const abbr = found && found.abbreviation ? found.abbreviation : ''
            return abbr ? `${abbr}` : `${alvId}`
        }
    },
    created() {
        const currentDomain = this.$store.getters.getSelectedMappingsDomainsFilter
        const currentDirection = this.$store.getters.getSelectedMappingsDirectionsFilter
        this.$store.commit('setSelectedMappingsDomainsFilter', ['publishing_statements', 'label_statements'])
        this.$store.commit('setSelectedMappingsDirectionsFilter', 'export')
        this.$store.dispatch('fetchMappingsByDomain').then(() => {
            this.$store.commit('setSelectedMappingsDomainsFilter', currentDomain)
            this.$store.commit('setSelectedMappingsDirectionsFilter', currentDirection)
        })
    },
    beforeDestroy() {
        this.$store.dispatch('fetchMappingsByDomain')
    }
}
</script>
